export var DATADOG_IGNORED_ERRORS = ["ResizeObserver loop"];
